module.exports = __webpack_public_path__ + "static/media/77.c92a3eef.gif";